import React from 'react';
import TestErrorBoundary from '../components/test/TestErrorBoundary';
import CalendarTestComponent from '../components/test/CalendarTestPage';

/**
 * Pagina di test per il calendario con ErrorBoundary
 */
const CalendarTestPage = () => {
  return (
    <TestErrorBoundary>
      <CalendarTestComponent />
    </TestErrorBoundary>
  );
};

export default CalendarTestPage;